import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getRoles = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/roles/lookup/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Roles fetch error:", error);
    throw error;
  }
};

const getUsers = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Users fetch error:", error);
    throw error;
  }
};

const createUser = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("User create error:", error);
    throw error;
  }
};

const getUserById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("User fetch error:", error);
    throw error;
  }
};

const updateUser = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("User update error:", error);
    throw error;
  }
};

const deleteUser = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("User delete error:", error);
    throw error;
  }
};

const updatePageAccess = async (id, pageAccess) => {
  try {
    const token = getToken();

    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/users/page-access/?id=${id}`,
      { page_access: pageAccess },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Page access update error:", error);
    throw error;
  }
};

export {
  getRoles,
  getUsers,
  createUser,
  getUserById,
  updateUser,
  deleteUser,
  updatePageAccess,
};
